export default __webpack_public_path__ + "static/media/paper-airplane.bea349ca.png";